<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <img class="logo-con-max" v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <!-- <el-drawer
      v-if="!screens.md"
      append-to-body
      custom-class="slidebar-menu"
      :visible.sync="collapsed"
      direction="ltr">
      <div style="height:100%;">
        <side-menu accordion ref="sideMenu" :active-name="$route.name"  @on-select="turnToPage" :menu-list="menuList">
          <div class="logo-con" :style="!screens.md ? 'height: 64px;padding: 10px;text-align:center' : ''">
            <img v-show="!collapsed || !screens.md" :style="!screens.md ? 'height: 44px;width: auto;' : ''" :src="maxLogo" key="max-logo" />
            <img v-show="collapsed && screens.md" :src="minLogo" key="min-logo" />
          </div>
        </side-menu>
      </div>
    </el-drawer> -->
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar"/>
          <!-- <language v-if="$config.useI18n" @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/> -->
          <!-- <error-store v-if="$config.plugin['error-store'] && $config.plugin['error-store'].showInHeader" :has-read="hasReadErrorPage" :count="errorCount"></error-store> -->
          <fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          <Content class="content-wrapper">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :include="cacheList">
                <router-view/>
              </keep-alive>
            </transition>
            <ABackTop :height="100" :bottom="20" :right="50" container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import Language from './components/language'
import ErrorStore from './components/error-store'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.png'
import maxLogo from '@/assets/images/logo-max.png'
import config from '@/config'
import './main.less'
// import ResponsiveObserver from 'responsive-observer'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop
  },
  data () {
    return {
      screens: {
        xl: false,
        lg: false,
        md: false,
        sm: false,
        xs: false
      },
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false
    }
  },
  computed: {
    ...mapGetters([
      'errorCount',
      'homeRoute'
    ]),
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvatar () {
      return this.$store.state.user.avatarImgPath
    },
    cacheList () {
      const list = [...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
      return list
    },
    menuList () {
      return this.$store.getters.menuList
    },
    local () {
      return this.$store.state.app.local
    },
    hasReadErrorPage () {
      return this.$store.state.app.hasReadErrorPage
    },
    unreadCount () {
      return this.$store.state.user.unreadCount
    }
  },
  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute',
      'closeTag'
    ]),
    ...mapActions([
      'handleLogin',
      'getUnreadMessageCount'
    ]),
    turnToPage (route) {
      // debugger
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }

      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName)
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route)
          }
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    }
  },
  watch: {
    '$route' (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })  
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    const { name, params, query, meta } = this.$route
    // 解决首次进入页面不是首页存在的bug
    this.setHomeRoute(routers)
    if (this.$route.name !== config.homeName) {
      this.addTag({route: this.homeRoute, notSetLocal: true})
      this.setTagNavList()
    } else {
      this.setTagNavList() 
    }
    this.addTag({
      route: { name, params, query, meta }
    })
    this.setBreadCrumb(this.$route, routers)
    // 设置初始语言
    if (this.$i18n) this.setLocal(this.$i18n.locale)
    // 获取未读消息条数
    this.getUnreadMessageCount()
  },
  created () {
    // this.observer = new ResponsiveObserver({
    //   xs: '(max-width: 767px)',
    //   sm: '(min-width: 768px)',
    //   md: '(min-width: 992px)',
    //   lg: '(min-width: 1200px)',
    //   xl: '(min-width: 1600px)'
    // })
    // this.observer.subscribe((screens) => {
    //   this.screens = screens
    // })
  },
  destroyed () {
    // if (this.observer) this.observer.unsubscribe()
  }
}
</script>
<style lang="less">
.slidebar-menu {
  width: 256px!important;
  .el-drawer__header {
    display: none;
  }
  background: #3B3939;
}
.logo-con {
  &-max {
    width: 192px!important;
    height: auto!important;
  }
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background: #911B21!important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue